export const ButtonLoader = () => {
    return (
        <span
            aria-hidden="true"
            className="inline-block h-5 w-5 shrink-0 rounded-full border-2 border-current border-t-transparent animate-spin"
        />
    )
}
